import { formData, authApi } from 'utils';

export const newTelegramCode = () => () =>
    authApi.post(`/shops/update_telegram_code`).then(res => {
        if (res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    });

export const getGroups = () => () =>
    authApi.get(`/telegram/groups?legacy=true-9812658`)
        .then(res => {
            return res
        })
        .catch(err => {
            throw err
        });